export const countries = [
    {
    "nombre": "Colombia",
    "valor": "Colombia"
    }
       ]